import React from 'react'
import PropTypes from 'prop-types'
import { ButtonStyled } from './style'
import { ChevronDown } from 'lucide-react'


const ButtonDropdown = ({ title, onClick, open, menuList, disabled }) => {
    return (
        <>
            <ButtonStyled
                size="small"
                aria-owns={open ? menuList : undefined}
                aria-haspopup="true"
                disabled={disabled}
                onClick={onClick}>
                <span>{title}</span>
                <ChevronDown size={18} className="button-dropdown-chevron" />
            </ButtonStyled>
        </>
    )
}

ButtonDropdown.propType = {
    title: PropTypes.string,
    onClick: PropTypes.func,
    open: PropTypes.bool,
    menuList: PropTypes.string
}

export default ButtonDropdown;
